module.exports = __webpack_public_path__ + "static/img/EPC_img.909202d.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/EPC_img.webp
// module id = Y3RH
// module chunks = 2